import { render } from "./PickingCriteriaSelector.vue?vue&type=template&id=4e22b313&scoped=true"
import script from "./PickingCriteriaSelector.vue?vue&type=script&lang=js"
export * from "./PickingCriteriaSelector.vue?vue&type=script&lang=js"

import "./PickingCriteriaSelector.vue?vue&type=style&index=0&id=4e22b313&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e22b313"]])

export default __exports__